import { request } from './core.api';

export interface RentalAgreementDto {
  id: string;
  tenantId: string;
  tenantName: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  propertyId: string;
  propertyAddress: string;
  rentAmount?: number;
  startDate?: string;
  endDate?: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRentalAgreementRequest {
  tenantId: string;
  propertyId: string;
  rentAmount: number;
  startDate: string;
  endDate?: string;
}

export interface UpdateRentalAgreementRequest {
  tenantId: string;
  propertyId: string;
  rentAmount: number;
  startDate: string;
  endDate?: string;
}

export const rentalAgreementsApi = {
  getAll: () => request<RentalAgreementDto[]>('/rental-agreements'),
  getByProperty: (propertyId: string) => request<RentalAgreementDto[]>(`/properties/${propertyId}/rental-agreements`),
  getByTenant: (tenantId: string) => request<RentalAgreementDto[]>(`/tenants/${tenantId}/rental-agreements`),
  create: (data: CreateRentalAgreementRequest) => request<RentalAgreementDto>('/rental-agreements', { method: 'POST', body: JSON.stringify(data) }),
  update: (id: string, data: UpdateRentalAgreementRequest) => request<RentalAgreementDto>(`/rental-agreements/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
};
